export const formatSeconds = seconds => {
  const minutes = Math.floor(seconds / 60);
  const extraSeconds = seconds % 60;
  return {
    minutes,
    seconds: extraSeconds
  };
};